import classNames from 'classnames'

import style from './style.scss'

type Props = React.HTMLProps<HTMLInputElement>

function Input({ className, ...props }: Props) {
  return <input className={classNames(style.input, className)} {...props} />
}

export default Input
